<template>
    <div>
        <el-form
            ref="form"
            :inline="true"
            :model="query"
            class="query-form"
            size="mini"
        >
            <el-form-item label="国家: " class="query-form-item" prop="state">
                <el-select
                    v-model="query.state"
                    ref="carrerSelect"
                    style="width: 150px;"
                    size="mini"
                    filterable
                    @change="change"
                >
                    <el-option
                        v-for="item in us_arr"
                        :key="item.us"
                        :label="item.title"
                        :value="item.us"
                        :disabled="item.disabled">
                        <div class="keywords_arr_div">
                            <icon-svg :icon-class="item.us.toUpperCase()"
                                      style="font-size: 24px;margin-right:5px;"></icon-svg>
                            <span style="font-weight: 700; font-size: 14px;margin-left: 10px;">{{ item.title }}</span>
                        </div>
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="showAddRecord = true">添加解析记录</el-button>
                <el-button type="success" @click="onupload">上传SB广告组广告位文件</el-button>
                <el-button type="primary" @click="onReset">刷新列表</el-button>
            </el-form-item>
        </el-form>
        <el-table
            v-loading="loading"
            :data="list"
            size="mini"
            ref="multipleTable"
            :height="tableHeight"
            @sort-change="handleSortChange"
            border
            style="width: 100%"
        >
            <el-table-column label="ID" width="80" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.id }}</div>
                </template>
            </el-table-column>
            <el-table-column
                label="国家"
                sortable="custom"
                prop="country_code"
                min-width="150"
                align="center"
            >
                <template slot-scope="scope">
                    <div>{{ scope.row.state }}</div>
                </template>
            </el-table-column>
            <el-table-column label="开始日期" min-width="150" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.start_date || "-" }}</div>
                </template>
            </el-table-column>
            <el-table-column label="结束日期" min-width="150" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.end_date || "-" }}</div>
                </template>
            </el-table-column>
            <el-table-column label="创建时间" min-width="150" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.add_time || "-" }}</div>
                </template>
            </el-table-column>
            <el-table-column label="操作" width="260">
                <template slot-scope="scope">
                    <el-button v-if="scope.row.status === -1" style="margin: 5px 0 5px 10px"
                               @click="showErrorInfo(scope.row)" type="danger" size="mini">解析失败
                    </el-button>
                    <el-button
                        v-if="scope.row.status === 0"
                        style="margin: 5px 0 5px 10px"
                        type="success"
                        size="mini"
                        @click="startDecode(scope.row)"
                    >开始解析</el-button
                    >
                    <el-button
                        v-if="scope.row.status === 1"
                        style="margin: 5px 0 5px 10px"
                        type="success"
                        size="mini"
                    >解析中</el-button
                    >
                    <el-button
                        v-if="scope.row.status === 2"
                        style="margin: 5px 0 5px 10px"
                        type="success"
                        @click="downFile(scope.row.parsing_path)"
                        size="mini"
                    >下载解析</el-button>
                    <el-button
                        v-if="scope.row.status !== 0 && scope.row.status !== 1"
                        style="margin: 5px 0 5px 10px"
                        type="success"
                        size="mini"
                        @click="startDecode(scope.row, 1)"
                    >重新解析</el-button>
                    <el-button
                        style="margin: 5px 0 5px 10px"
                        type="danger"
                        size="mini"
                        @click="delete_records(scope.row)"
                    >删除</el-button
                    >
                </template>
            </el-table-column>
        </el-table>
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :page-size="query.limit"
            :page-sizes="[10, 50, 100]"
            :total="query.total"
            background
            style="float: right;margin-top: 10px; margin-bottom: 5px"
            layout="total, sizes, prev, pager, next"
        >
        </el-pagination>
        <upload
            :visible="ctrl.uploadDialogVisible"
            :us_arr="us_arr"
            :title="'上传SB广告组广告位文件'"
            @close-callback="closeCllback"
        ></upload>
        <addParaseRcord
            :visible="showAddRecord"
            :title="'添加解析记录'"
            @close-callback="closeCllback"
        ></addParaseRcord>
        <el-dialog style="padding: 0 20px 20px 20px !important;" width="30%" center title="错误信息" v-if="errorInfoShow"
                   :visible.sync="errorInfoShow">
            <span style="color: red">错误内容：</span>
            <span>{{errorMsg}}</span>
            <span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="errorInfoShow = false">关 闭</el-button>
			</span>
        </el-dialog>
    </div>
</template>

<script>
    import * as api from '@/api/Product/Product'
    import * as Highcharts from 'highcharts'
    import { downloadFileUrl } from "@/utils/method";
    import Upload from "./upload";
    import DownloadList from '../../statistics/downloadList'
    import DownloadView from '../../statistics/downloadView'
    import AddPpc from '../../statistics/addPpc'
    import BidList from '../../statistics/bidList'
    import addParaseRcord from './addParaseRcord'
    import AddBaseAdData from '../../statistics/components/addBaseAdData'


    export default {
        components: {
            // AddBaseAdData,
            Upload,
            // DownloadList,
            // DownloadView,
            // AddPpc,
            // BidList,
            addParaseRcord
        },
        data() {
            return {
                errorMsg: '',
                errorInfoShow: false,
                showAddRecord: false,
                ctrl: {
                    addDialogVisible: false,
                    addMonthDialogVisible: false,
                    charts_keywordVisible: false,
                    charts_keywordMonthVisible: false,
                    uploadDialogVisible: false,
                    upload1DialogVisible: false,
                    errorVisible: false
                },
                tableHeight: null,
                formData: {},
                query: {
                    state: "",
                    page: 1,
                    limit: 10,
                },
                us_arr: [
                    {
                        us: 'US',
                        title: '美国'
                    },
                    {
                        us: 'UK',
                        title: '英国'
                    },
                    {
                        us: 'DE',
                        title: '德国'
                    }
                ],
                list: [],
                listData: [],
                requestCount: 0,
                charts_keyword: '',
                country_code_str: '',
                loadingkeyword_tracker: false,
                disabled: false,
                loading: false,
                rules: {
                    state: [
                        {
                            required: true,
                            message: '请选择国家',
                            trigger: 'blur'
                        }
                    ]
                },
            }
        },
        created() {
            this.getList()
        },
        mounted() {
            this.tableHeight =
                window.innerHeight - 140 - this.$refs.form.$el.offsetHeight
            const that = this
            window.onresize = () => {
                return (() => {
                    if (typeof that.$refs.form == 'object') {
                        that.tableHeight =
                            window.innerHeight -
                            140 -
                            that.$refs.form.$el.offsetHeight
                    }
                })()
            }
        },
        watch: {
            tableHeight(val) {
                this.tableHeight = val
            },
            list: function () {
                this.$nextTick(function () {
                    for (let i = 0; i < this.list.length; i++) {
                        if (this.list[i].show_num_sum) {
                            this.workload_tracker(
                                'keyword_tracker' +
                                this.list[i].keyword +
                                this.list[i].country_code,
                                this.list[i]
                            )
                            this.workload_tracker_month(
                                'keyword_tracker_month' +
                                this.list[i].keyword +
                                this.list[i].country_code,
                                this.list[i]
                            )
                        }
                    }
                })
            }
        },
        methods: {
            showErrorInfo(info) {
                this.errorInfoShow = true;
                this.errorMsg = info.parsing_err_msg;
            },
            delete_records(data) {
                this.$confirm("确认删除该记录吗?", "提示", {
                    type: "warning"
                }).then(() => {
                    api.sb_ad_position_analysis_delete({ id: data.id }).then(() => {
                        this.$message.success("删除成功");
                        this.getList();
                    });
                });
            },
            // 关闭弹窗回调
            closeCllback(isshow) {
                this.ctrl.uploadDialogVisible = false
                this.showAddRecord = false;
                isshow == true && this.getList();
            },
            //上传文件
            onupload() {
                this.ctrl.uploadDialogVisible = true;
            },
            downFile(path) {
                if (!path) {
                    return this.$message({
                        type: "error",
                        message: "无法下载！"
                    });
                }
                downloadFileUrl(path);
            },
            async startDecode(row, force = 0) {
                if (force) {
                    await this.$confirm("是否重新运行解析任务", "提示", {
                        confirmButtonText: "确定",
                        cancelButtonText: "取消",
                        type: "warning"
                    });
                }
                let list = JSON.parse(JSON.stringify(this.list));
                api.sb_ad_position_analysis_parsing_file({
                    id: row.id,
                    force
                }).then(() => {
                    const index = list.findIndex(item => item.id === row.id);
                    list[index].status = 1;
                    this.list = list;
                });
            },
            change() {
                this.getList()
            },
            handleSortChange(val) {
                let obj = {}
                if (val.order == 'ascending') {
                    obj.desc = 0
                    obj.field = val.prop
                } else if (val.order == 'descending') {
                    obj.desc = 1
                    obj.field = val.prop
                }
                this.query.order = obj
                this.getList()
            },
            exportData() {
                this.ctrl.upload1DialogVisible = true
            },
            latelyExportData() {
                this.ctrl.uploadDialogVisible = true
            },
            getList() {
                let count = this.requestCount
                count = count + 1
                this.requestCount = count
                this.loading = true
                this.loadingkeyword_tracker = true
                api.sb_analysis_list(this.query)
                    .then(res => {
                        this.loading = false
                        if (this.requestCount != count) {
                            this.loadingkeyword_tracker = false
                            return
                        }
                        if (res.code === 0) {
                            this.list = res.data.list
                            this.query.page = res.data.page
                            this.query.total = res.data.total
                            let arr_key_obj = {}
                            let that = this
                            let list = JSON.parse(JSON.stringify(that.list))
                            for (let i = 0; i < list.length; i++) {
                                if (
                                    arr_key_obj[list[i].country_code] == undefined
                                ) {
                                    arr_key_obj[list[i].country_code] = []
                                }
                                arr_key_obj[list[i].country_code].push(
                                    list[i].keyword
                                )
                            }
                            if (JSON.stringify(arr_key_obj) != '{}') {
                                for (let key in arr_key_obj) {
                                    this.trend_batch(arr_key_obj[key], key, count)
                                    // this.trend_batch_by_month(arr_key_obj[key], key, count);
                                }
                            } else {
                                this.loadingkeyword_tracker = false
                            }
                        } else {
                            this.$message({
                                type: 'error',
                                message: res.message
                            })
                        }
                    })
                    .catch(() => {
                        this.loading = false
                    })
            },
            //获取关键词曲线图数据
            async trend_batch(arr, country_code, count) {
                let that = this
                if (that.requestCount != count) {
                    return (that.loadingkeyword_tracker = false)
                }
                await api.sb_search_trend({
                    keywords: arr,
                    country_code: country_code
                })
                    .then(res => {
                        that.loadingkeyword_tracker = false
                        if (that.requestCount != count) return
                        let list = JSON.parse(JSON.stringify(that.list))
                        if (res.code === 0) {
                            let data = res.data
                            for (let i = 0; i < list.length; i++) {
                                if (list[i].country_code == country_code) {
                                    list[i].show_num_sum_date =
                                        data[list[i].keyword].date
                                    list[i].show_num_sum =
                                        data[list[i].keyword].show_num_sum
                                    list[i].keyword_show_share_num =
                                        data[list[i].keyword].keyword_show_share_num
                                }
                            }
                            that.list = list
                        } else {
                            that.$message({
                                type: 'error',
                                message: res.message
                            })
                        }
                    })
                    .catch(() => {
                        that.loadingkeyword_tracker = false
                    })
            },
            //获取关键词曲线图数据-月
            async trend_batch_by_month(arr, country_code, count) {
                let that = this
                if (that.requestCount != count) {
                    return (that.loadingkeyword_tracker = false)
                }
                await api.search_trend_batch_by_month({
                    keywords: arr,
                    country_code: country_code
                })
                    .then(res => {
                        that.loadingkeyword_tracker = false
                        if (that.requestCount != count) return
                        let list = JSON.parse(JSON.stringify(that.list))
                        if (res.code === 0) {
                            let data = res.data
                            for (let i = 0; i < list.length; i++) {
                                if (list[i].country_code == country_code) {
                                    list[i].show_num_sum_date_month =
                                        data[list[i].keyword].date
                                    list[i].show_num_sum_month =
                                        data[list[i].keyword].show_num_sum
                                    list[i].keyword_show_share_num_month =
                                        data[list[i].keyword].keyword_show_share_num
                                }
                            }
                            that.list = list
                        } else {
                            that.$message({
                                type: 'error',
                                message: res.message
                            })
                        }
                    })
                    .catch(() => {
                        that.loadingkeyword_tracker = false
                    })
            },
            workload_tracker(id_name, data) {
                let workload_id = document.getElementById(id_name)
                let datas = []
                for (let i = 0; i < data.show_num_sum.length; i++) {
                    datas.push(
                        data.show_num_sum[i] == null
                            ? null
                            : data.show_num_sum[i] * -1
                    )
                }
                this.sparkLine(workload_id, datas, data.show_num_sum_date, 2)
            },
            workload_tracker_month(id_name, data) {
                let workload_id = document.getElementById(id_name)
                let datas = []
                for (let i = 0; i < data.show_num_sum_month.length; i++) {
                    datas.push(
                        data.show_num_sum_month[i] == null
                            ? null
                            : data.show_num_sum_month[i] * -1
                    )
                }
                this.sparkLine(workload_id, datas, data.show_num_sum_date_month, 2)
            },
            sparkLine(div, datas, dates, index) {
                var options = {
                    chart: {
                        borderWidth: 0,
                        type: 'area',
                        margin: [8, 40, 8, 10],
                        width: 100,
                        height: 36,
                        style: {
                            overflow: 'visible'
                        },
                        skipClone: true
                    },
                    title: {
                        text: null
                    },
                    credits: {
                        enabled: false
                    },
                    xAxis: {
                        categories: dates,
                        labels: {
                            enabled: false
                        },
                        title: {
                            text: null
                        },
                        startOnTick: false,
                        endOnTick: false,
                        tickPositions: [],
                        tickWidth: 0,
                        lineColor: '#fff'
                    },
                    yAxis: {
                        reversed: index == 1 ? false : true,
                        labels: {
                            enabled: false
                        },
                        title: {
                            text: null
                        },
                        minPadding: 0,
                        startOnTick: false,
                        endOnTick: false,
                        tickPositions: []
                    },
                    legend: {
                        enabled: false
                    },
                    exporting: {enabled: false},
                    tooltip: {
                        formatter: function () {
                            if (index == 1) {
                                return `<span style="font-size: 10px;">${
                                    this.x
                                }</span><br/><b>${306 - this.y}</b>`
                            }
                            if (index == 2) {
                                return `<span style="font-size: 10px;">${
                                    this.x
                                }</span><br/><b>${this.y * -1}</b>`
                            }
                        },
                        hideDelay: 0,
                        outside: true
                    },
                    series: [{data: datas}],
                    plotOptions: {
                        series: {
                            animation: false,
                            lineWidth: 1,
                            shadow: false,
                            states: {
                                hover: {
                                    lineWidth: 1
                                }
                            },
                            marker: {
                                radius: 1,
                                states: {
                                    hover: {
                                        radius: 2
                                    }
                                }
                            },
                            fillOpacity: 0.25
                        },
                        column: {
                            negativeColor: '#910000',
                            borderColor: 'silver'
                        }
                    }
                }
                return new Highcharts.Chart(div, options)
            },
            //打开关键词曲线图
            oncharts_keyword(data) {
                let that = this
                this.charts_keyword = data.keyword
                this.ctrl.dialogTitle = `${data.keyword} 的日搜索趋势图`
                this.ctrl.charts_keywordVisible = true
                setTimeout(function () {
                    that.$refs.charts_keyword_.getList(
                        data.keyword,
                        null,
                        data.country_code
                    )
                }, 100)
            },//打开关键词曲线图
            oncharts_keyword_month(data) {
                let that = this
                this.charts_keyword = data.keyword
                this.ctrl.dialogTitle = `${data.keyword} 的月搜索趋势图`
                this.ctrl.charts_keywordMonthVisible = true
                setTimeout(function () {
                    that.$refs.charts_keyword_month_.getList(
                        data.keyword,
                        null,
                        data.country_code
                    )
                }, 100)
            },
            //错误内容
            errorPageDialog() {
                this.ctrl.errorVisible = true
            },
            //错误页面
            errorDialog(data) {
                let that = this
                this.listData = data.data
                setTimeout(function () {
                    that.errorPageDialog()
                }, 10)
            },
            //添加文件夹
            add() {
                this.ctrl.addDialogVisible = true
            },
            //添加文件夹
            addMonth() {
                this.ctrl.addMonthDialogVisible = true
            },
            //分页
            handleCurrentChange(val) {
                this.query.page = val
                this.getList()
            },
            handleSizeChange(val) {
                this.query.limit = val
                this.getList()
            },
            //重置
            onReset() {
                this.query.page = 1
                this.query.limit = 20
                this.getList()
            },
            //查询
            onSubmit() {
                this.getList()
            },
        }
    }
</script>

<style type="text/scss" lang="scss" scoped>
    /deep/ .el-table--enable-row-hover .el-table__body tr:hover > td {
        background-color: #fff !important;
    }

    /deep/ .el-button--mini {
        padding: 5px 5px !important;
    }

    .pen:hover {
        cursor: pointer;
        text-decoration: underline;
    }
</style>
